module.exports = __webpack_public_path__ + "static/img/0001眼保健2.b21c0ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/0001眼保健2.jpg
// module id = Lu4P
// module chunks = 0